import { sendGet, sendPost } from '../hooks/use-fetch'
import { type UserPermission } from '../utils/genericTypes'
import { type Response } from '../hooks/use-fetch'

export async function GetPermissionsForRole (roleName: string): Promise<Response<UserPermission[]>> {
  return await sendGet(`User/UserPermissionsByRole?userSecurityLevel=${roleName}`)
}

export async function GetUserFunctionsForOrg (userId: number, orgId: number): Promise<Response<string[]>> {
  return await sendGet(`User/UserFunctionsByOrganization?userId=${userId}&organizationId=${orgId}`)
}

export async function GetOwnFunctionsForOrg (orgId: number): Promise<Response<string[]>> {
  return await sendGet(`User/OwnFunctionsByOrganization?organizationId=${orgId}`)
}

export async function SaveUserFunctions (userId: number, orgId: number, securityLevel: string, functions: string[]): Promise<Response> {
  return await sendPost('User/SaveUserFunctions', { userId, organizationId: orgId, securityLevel, functions })
}

export async function RemoveAccessToOrganization (userId: string, orgId: number): Promise<Response> {
  return await sendPost('User/RemoveAccessToOrganization', { userId, organizationId: orgId })
}
